import { STORAGE_KEYS } from '@/config/storage-config';

const createStorageHandler = (key: string) => ({
  get: (): string => localStorage.getItem(key) || '',
  set: (value: string): void => localStorage.setItem(key, value),
  remove: (): void => localStorage.removeItem(key),
});

export const tokenStorage = createStorageHandler(STORAGE_KEYS.TOKEN);
export const refreshTokenStorage = createStorageHandler(STORAGE_KEYS.REFRESH_TOKEN);
export const sessionIdStorage = createStorageHandler(STORAGE_KEYS.SESSION_ID);
